import dynamic from "next/dynamic";

import { useRouter, usePathname } from "next/navigation";
import React, { Fragment, useEffect, useState } from "react";
import { toast } from "react-toastify";
import Link from "next/link";
import Icon from "@/components/ui/Icon";
import Image from "next/image";
import useMobileMenu from "@/hooks/useMobileMenu";
import Submenu from "./Submenu";

const Navmenu = ({ menus }) => {
  const router = useRouter();
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const contractAddress = "0x0A10D108E2d81ccC793E37b56206C84bF96ddc57";

  const handleCopyAddress = () => {
    navigator.clipboard.writeText(contractAddress).then(() => {
      toast.success("Copied to clipboard!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
  };

  const toggleSubmenu = (i) => {
    if (activeSubmenu === i) {
      setActiveSubmenu(null);
    } else {
      setActiveSubmenu(i);
    }
  };

  const location = usePathname();
  const normalizePath = (p) =>
    (p || "").split("?")[0].split("#")[0].replace(/^\/+/, "");
  const locationName = normalizePath(location);

  const [mobileMenu, setMobileMenu] = useMobileMenu();

  useEffect(() => {
    let submenuIndex = null;
    menus.map((item, i) => {
      if (!item.child) return;
      const parentLink = normalizePath(item.link);
      const isParentMatch =
        parentLink &&
        (locationName === parentLink ||
          locationName.startsWith(parentLink + "/"));
      if (isParentMatch) {
        submenuIndex = i;
        return;
      }
      const hasActiveChild = item.child.some((ci) => {
        const childLink = normalizePath(ci.childlink);
        return (
          locationName === childLink || locationName.startsWith(childLink + "/")
        );
      });
      if (hasActiveChild) {
        submenuIndex = i;
      }
    });

    setActiveSubmenu(submenuIndex);
    if (mobileMenu) {
      setMobileMenu(false);
    }
  }, [router, location]);

  const isItActive = (link) => {
    const linkNorm = normalizePath(link.link);
    if (!link.child) {
      if (link.link === "/") return location === "/";
      return (
        locationName === linkNorm || locationName.startsWith(linkNorm + "/")
      );
    }
    return false;
  };

  return (
    <Fragment>
      <div className="flex flex-col justify-between h-[80vh]">
        <div>
          <ul className="mt-6">
            {menus.map((item, i) => (
              <li
                key={i}
                className={` single-sidebar-menu 
              ${item.child ? "item-has-children" : ""}
              ${activeSubmenu === i ? "open" : ""}
              ${isItActive(item) ? "menu-item-active" : ""}`}
              >
                {/* single menu with no childred*/}
                {!item.child && !item.isHeadr && !item.isHide && (
                  <Fragment>
                    {item.isExternal ? (
                      <a
                        className="!text-metaxseed-gray px-2 hover:!text-white flex items-center transition-all font-semibold py-3"
                        href={item.link}
                        target="_blank"
                      >
                        <span className="flex-grow-0 text-lg inline-flex items-center ltr:mr-3 rtl:ml-3 pb-1">
                          <Icon icon={item.icon} />
                        </span>
                        <div className="text-box text-left text-lg py-1">
                          {item.title}
                        </div>
                        {item.badge && (
                          <span className="menu-badge ml-3 inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-medium bg-gray-800/50 text-gray-300 border-gray-700">
                            {item.badge}
                          </span>
                        )}
                      </a>
                    ) : (
                      <Link
                        className="!text-metaxseed-gray px-2 hover:!text-white flex items-center transition-all font-semibold py-3"
                        href={item.link}
                      >
                        <span className="flex-grow-0 text-lg inline-flex items-center ltr:mr-3 rtl:ml-3 pb-1">
                          <Icon icon={item.icon} />
                        </span>
                        <div className="text-box text-left text-lg py-1">
                          {item.title}
                        </div>
                        {item.badge && (
                          <span className="menu-badge ml-3 inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-medium bg-gray-800/50 text-gray-300 border-gray-700">
                            {item.badge}
                          </span>
                        )}
                      </Link>
                    )}
                  </Fragment>
                )}
                {/* only for menulabel */}
                {/* {item.isHeadr && !item.child && (
              <div className="menulabel text-lg">{item.title}</div>
            )} */}
                {/*    !!sub menu parent   */}
                {item.child &&
                  (item.link ? (
                    <Link
                      href={item.link}
                      onClick={(e) => {
                        if (activeSubmenu !== i) {
                          e.preventDefault();
                          setActiveSubmenu(i);
                        }
                      }}
                      className={`group !text-metaxseed-gray px-2 hover:!text-white flex items-center transition-all font-semibold py-3 cursor-pointer ${
                        activeSubmenu === i
                          ? "parent_active not-collapsed"
                          : "collapsed"
                      }`}
                    >
                      <div className="flex-1 flex  !text-metaxseed-gray group-hover:!text-white">
                        <span className="flex-grow-0 text-lg inline-flex items-center ltr:mr-3 rtl:ml-3 pb-1">
                          <Icon icon={item.icon} />
                        </span>
                        <div className="text-box text-lg">{item.title}</div>
                      </div>
                      <div className="flex-0">
                        <div
                          className={`menu-arrow transform transition-all duration-300 ${
                            activeSubmenu === i ? " rotate-90" : ""
                          }`}
                        >
                          <Icon icon="heroicons-outline:chevron-right" />
                        </div>
                      </div>
                    </Link>
                  ) : (
                    <div
                      className={`group !text-metaxseed-gray px-2 hover:!text-white flex items-center transition-all font-semibold py-3 cursor-pointer ${
                        activeSubmenu === i
                          ? "parent_active not-collapsed"
                          : "collapsed"
                      }`}
                      onClick={() => toggleSubmenu(i)}
                    >
                      <div className="flex-1 flex  !text-metaxseed-gray group-hover:!text-white">
                        <span className="flex-grow-0 text-lg inline-flex items-center ltr:mr-3 rtl:ml-3 pb-1">
                          <Icon icon={item.icon} />
                        </span>
                        <div className="text-box text-lg">{item.title}</div>
                      </div>
                      <div className="flex-0">
                        <div
                          className={`menu-arrow transform transition-all duration-300 ${
                            activeSubmenu === i ? " rotate-90" : ""
                          }`}
                        >
                          <Icon icon="heroicons-outline:chevron-right" />
                        </div>
                      </div>
                    </div>
                  ))}
                <Submenu
                  activeSubmenu={activeSubmenu}
                  item={item}
                  i={i}
                  locationName={locationName}
                />
              </li>
            ))}
          </ul>
          <div className="flex  gap-1 items-center text-sm gothamMedium bg-gradient-to-r from-orange-500 to-yellow-500 text-white py-3 px-2 rounded-md mt-5">
            <Image
              src="https://res.cloudinary.com/dot2onqdb/image/upload/v1729067770/xseed_lr_is7mcx.png"
              className="w-6 h-6 mr-2"
              alt="XSEED TOKEN"
              width={24}
              height={24}
            />
            <button
              className="gotham"
              onClick={() =>
                window.open(
                  "https://snowtrace.io/token/0x0A10D108E2d81ccC793E37b56206C84bF96ddc57?chainid=43114",
                  "_blank",
                )
              }
            >
              XSEED Contract
            </button>
            <div onClick={handleCopyAddress}>
              <Icon
                icon="basil:copy-solid"
                className="cursor-pointer w-[20px] h-[20px]"
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Navmenu;
